"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SUPPORTED_FILES = exports.SUPPORTED_IMAGES = void 0;
exports.SUPPORTED_IMAGES = [
    '.jpg',
    '.jpeg',
    '.png',
    '.webp',
    '.gif',
    '.svg',
];
exports.SUPPORTED_FILES = ['.docx', '.doc', '.pdf', '.zip'];
